import { makeGraphQLQuery } from '../request.gql';

/**
 * Coverages
 */
export const queryCoveragesByMember = async ({member, token}) => {
    const {r,e} = await makeGraphQLQuery({
        query: `query ($member: String!) {
            coverages (member: $member) {
                id,
                product {
                    id,
                    productKey,
                    name,
                    order,
                    summaryUrl,
                    type,
                    description,
                },
                options {
                    id,
                    optionKey,
                    type,
                    option,
                    plan,
                    name,
                    sumAssured,
                    isRequiredHdf,
                    description,
                    order,
                    price,
                    isDefault
                },
                selectOption {
                    id,
                },
            }
        }`,
        variables: {member,},
        token,
    });
    if (e) return e;
    return r.coverages;
};
export const checkoutSelection = async ({token}) => {
    const {r,e} = await makeGraphQLQuery({
        query: `mutation { checkout_selection }`,
        variables: {},
        token,
    });
    if (e) return e;
    return r.checkout_selection;
};
export const choosePaymentMethod = async ({method, token}) => {
    const {r,e} = await makeGraphQLQuery({
        query: `mutation ChoosePaymentMethod ($method: String!) {
            choose_payment_method(method: $method)
        }`,
        variables: {method},
        token,
    });
    if (e) return e;
    return r.choose_payment_method;
};
export const updateCoverageSelectedOption = async ({
    coverageId,
    optionId,
    token,
}) => {
    const {r,e} = await makeGraphQLQuery({
        query: `mutation ($coverageId: ID!, $optionId: String!) {
            coverage_option_change(id: $coverageId, selectOption: $optionId) 
        }`,
        variables: {
            coverageId,
            optionId,
        },
        token,
    });
    if (e) return e;
    return r.coverage_option_change;
};
export const queryCoveragesHistoryByMember = async ({member, token}) => {
    const {r,e} = await makeGraphQLQuery({
        query: `query ($member: String!) {
            past_coverages(member: $member) {
                id
                effectiveStartDate
                effectiveEndDate
                product {
                  id
                  name
                  order
                  summaryUrl
                }
                selectOption {
                  name
                  price
                }
                status
                benefitPeriod {
                  id
                  name
                  startDate
                }
            }
        }`,
        variables: {member,},
        token,
    });
    if (e) return e;
    return r.past_coverages;
};
